import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './ProductsBrowser.css';

function ProductsBrowser({ guruSlug }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchProducts();
  }, [guruSlug]);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      // Fetch products for the specific guru
      const response = await api.get(`/gurus/${guruSlug}/products`);
      setProducts(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching products:', err);
      setError('Failed to load products');
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="products-browser">
        <div className="products-loading">Loading products...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="products-browser">
        <div className="products-error">{error}</div>
      </div>
    );
  }

  return (
    <div className="products-browser">
      <div className="products-header">
        <h2 className="products-title">My All Access</h2>
        <p className="products-subtitle">Explore all your available trading strategies and tools</p>
      </div>

      <div className="products-grid">
        {products.map((product) => (
          <a
            key={product.id}
            href={product.oct_url || `https://app.oneclicktrading.com/product/${product.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className="product-card"
          >
            <div className="product-image-wrapper">
              {product.logo_url ? (
                <img
                  src={product.logo_url}
                  alt={product.name}
                  className="product-image"
                />
              ) : (
                <div className="product-placeholder">
                  <span>{product.name.charAt(0)}</span>
                </div>
              )}
            </div>
            <div className="product-info">
              <div className="product-name">{product.name}</div>
              <div className="product-sku">{product.sku}</div>
            </div>
          </a>
        ))}
      </div>

      {products.length === 0 && (
        <div className="no-products">
          <p>No products available.</p>
        </div>
      )}
    </div>
  );
}

export default ProductsBrowser;
